import React from "react";

function Header(){
    return <header className="header"> <h1>התזכורות שלי</h1> </header>
}
export default Header;